import React from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

import Button from "components/atoms/Button";
import HtmlHead from "components/atoms/HtmlHead";
import Text from "components/atoms/text/Text";

import GuestUserLayout from "components/templates/GuestUserLayout";

const Container = styled.div`
    position: relative;
    top: -40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: calc(100vh - 56px);
    background-color: var(--color-White);

    > a {
        text-decoration: none;
    }
`;

const ContactLink = styled.a`
    font-weight: 600;
    color: var(--color-Key);
    text-decoration: underline !important;
    cursor: pointer;
`;

const ErrorTitle = styled(Text).attrs({
    variant: "title-lg-500",
    color: "var(--color-Key)",
    textAlign: "center",
})``;

function ErrorPage(props) {
    const navigate = useNavigate();

    return (
        <GuestUserLayout noHeader>
            <HtmlHead title={"문제 발생"} />
            <Container>
                <ErrorTitle>
                    죄송합니다.
                    <br />
                    서비스에 문제가 발생했습니다.
                </ErrorTitle>
                <Text variant="body-lg" margin={"24px 0 0 0"} textAlign={"center"}>
                    일시적인 문제로 인해 서비스 이용에 불편을 드려 죄송합니다. 잠시후에 다시 시도해주세요.
                    <br />
                    문제가 계속되면 <ContactLink href={"mailto:prep@datansoft.com"}>문의</ContactLink>해주시기 바랍니다.
                </Text>
                <Button
                    onlyText
                    margin={"40px 0 0 0"}
                    width={"280px"}
                    height={"48px"}
                    bgColor={"var(--color-Button2)"}
                    hoverBgColor={"var(--color-ButtonHover2)"}
                    fontColor={"var(--color-White)"}
                    buttonText={"메인으로 돌아가기"}
                    onClick={(e) => {
                        e.preventDefault();
                        navigate("/");
                    }}
                />
            </Container>
        </GuestUserLayout>
    );
}

export default ErrorPage;
